module.exports = __webpack_public_path__ + "img/seo.c204c074.png";